import { Checkbox } from '@material-ui/core';
import React from 'react';

const Checkboxes = ({ ...props }) => (
  <div className="someAnswer">
    <h6>
      {props.index}
      .
      {props.question.text}
    </h6>
    <span className="subtitle1">
      Правильных выриантов ответа может быть несколько
    </span>
    <div className="answerOption">
      {props.question.answers.items.map((answer, key) => (
        <span key={key} className="body1">
          <Checkbox
            checked={props.answer.answers.indexOf(answer.self) !== -1}
            onClick={() => props.onAnswer({
              question: props.question.self,
              answer: answer.self,
              type: 'select',
            })}
            color="primary"
          />
          {answer.image ? (
            <img
              onClick={() => props.onImageClick(answer.image && answer.image.url)}
              className="answerPhoto"
              src={answer.image && answer.image.url}
            />
          ) : (
            answer.text
          )}
        </span>
      ))}
    </div>
  </div>
);

export default Checkboxes;
